module.exports = __webpack_public_path__ + "img/7.dce60227.webp";